// extracted by css-extract-rspack-plugin
export default {"dbCard":"vpC1K","addCard":"Ldx6H"};